import { API, Auth, Hub } from "aws-amplify";
import React, { useState, useEffect, useContext } from "react";
import { createContext } from "react";
import { getUser } from "./graphql/queries";
import { getProctorUsername } from "./Components/PodV2/sessionUtils";

const UserContext = createContext({});

export default function AuthContext({ children }) {
  const [user, setUser] = useState(null);
  const [isUser, setIsUser] = useState(false);
  const [proctorName, setProctorName] = useState("");

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log("user", user);
        setUser(user);
        setIsUser(true);
        sessionStorage.setItem("user", JSON.stringify(user));
      })
      .catch(() => {
        setUser(null);
        setIsUser(false);
        setProctorName("");
        if (sessionStorage.getItem("user")) {
          sessionStorage.removeItem("user");
        }
      });

    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signOut":
          setUser(null);
          setIsUser(false);
          setProctorName("");
          sessionStorage.removeItem("user");
          break;
        default:
          break;
      }
    });
  }, []);

  useEffect(() => {
    let cancelled = false;

    if (!user) {
      setProctorName("");
      return undefined;
    }

    const email = user?.attributes?.email || "";
    setProctorName((getProctorUsername(null, email) || "").trim());

    async function loadProctorName() {
      try {
        const cognitoUser = await Auth.currentUserInfo();
        const userId = cognitoUser?.id;
        const currentEmail =
          cognitoUser?.attributes?.email || user?.attributes?.email || "";

        if (!userId) {
          if (!cancelled) {
            setProctorName(
              (getProctorUsername(null, currentEmail) || "").trim()
            );
          }
          return;
        }

        const result = await API.graphql({
          query: getUser,
          variables: { id: userId },
        });
        const userRecord = result?.data?.getUser || null;
        const name = (getProctorUsername(userRecord, currentEmail) || "").trim();

        if (!cancelled) {
          setProctorName(name);
        }
      } catch (error) {
        // Keep the Claim fallback already set; do not break auth.
      }
    }

    loadProctorName();

    return () => {
      cancelled = true;
    };
  }, [user]);

  return (
    <UserContext.Provider
      value={{ user, setUser, isUser, setIsUser, proctorName }}
    >
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);
